<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :fieldReadonly="board.readonly" :board="board" :is-print="isPrint" :vislbleAlert="true" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />
    <!-- 작성 활성화 -->
    <h5 class="mt-7 mb-4"><i class="dot"></i> 작성 활성화</h5>
    <div class="grid grid-cols-1 xl:grid-cols-6">
      <div class="p-2">
        <PrintCheckbox :color="!board.readonly && !stepEditActive" label="수급업체 작성" :value="true" />
      </div>
      <div class="p-2">
        <PrintCheckbox :color="stepEditActive" label="직영 작성" :value="stepEditActive" :clickable="true" :disabled="!canStepEdit" @input="stepEditActive = $event" />
      </div>
    </div>

    <div>
      <!-- 부가정보 : 수급업체 작성-->
      <write-grid-container title="수급업체 작성" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
        <template slot-scope="{ index, label, value, dataType }">
          <div v-if="isPrint" class="printing">
            <div v-if="dataType === 'file' && form.subInfo[value]" class="print-input">{{ form.subInfo[value].fileName }}</div>
            <div v-else-if="dataType === 'textarea'" class="print-textarea">{{ form.subInfo[value] }}</div>
            <div v-else class="print-input">{{ form.subInfo[value] }}</div>
          </div>

          <div v-else class="write-grid-container-col">
            <FileUploader v-if="dataType === 'file'" :readonly="board.readonly" v-model="form.subInfo[value]" />
            <ml-textarea v-else-if="dataType === 'textarea'" :readonly="board.readonly" rows="5" v-model="form.subInfo[value]" class="w-full mb-0" />
            <DateSelector v-else-if="dataType === 'date'" :readonly="board.readonly" v-model="form.subInfo[value]" class="w-full" />
            <div v-else-if="dataType === 'number'" class="flex items-center justify-center gap-3">
              <NumberInput :readonly="board.readonly" v-model="form.subInfo[value]" class="w-full" />
              <span>명</span>
            </div>
            <ml-input v-else :readonly="board.readonly" class="w-full" v-model="form.subInfo[value]" visible-counter />
          </div>
        </template>
      </write-grid-container>

      <table>
        <colgroup>
          <col width="114" />
        </colgroup>
        <thead>
          <tr>
            <th>구분</th>
            <th>안전</th>
            <th>보건</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>기술지도 기관</th>
            <td><ml-input :readonly="board.readonly" v-model="form.기술지도기관안전" /></td>
            <td><ml-input :readonly="board.readonly" v-model="form.기술지도기관보건" /></td>
          </tr>
          <tr>
            <th>기술지도 일시</th>
            <td><DateSelector :readonly="board.readonly" v-model="form.기술지도일시안전" class="w-full" /></td>
            <td><DateSelector :readonly="board.readonly" v-model="form.기술지도일시" class="w-full" /></td>
          </tr>
          <tr>
            <th>기술지도 결과서</th>
            <td><FileUploader :readonly="board.readonly" v-model="form.기술지도결과서안전" /></td>
            <td><FileUploader :readonly="board.readonly" v-model="결과서첨부Proxy" /></td>
          </tr>
          <tr>
            <th>기술지도 사항</th>
            <td><ml-textarea :readonly="board.readonly" v-model="form.기술지도사항안전" class="mb-0" /></td>
            <td><ml-textarea :readonly="board.readonly" v-model="form.기술지도사항보건" class="mb-0" /></td>
          </tr>
          <tr>
            <th>기타 특이사항<br />(현장 점검 결과)</th>
            <td><ml-textarea :readonly="board.readonly" v-model="form.기타특이사항안전" class="mb-0" /></td>
            <td><ml-textarea :readonly="board.readonly" v-model="form.기타특이사항보건" class="mb-0" /></td>
          </tr>
          <tr>
            <th>개선 요청 사항<br />(업체 → DKS)</th>
            <td colspan="2"><ml-textarea :readonly="board.readonly" v-model="form.개선요청사항" class="mb-0" /></td>
          </tr>
        </tbody>
      </table>

      <!-- 개선 요청 사항 사진(필요 시) -->
      <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="개선 요청 사항 사진(필요 시)" placeholder="사진 설명" />
    </div>

    <!-- 직영 작성 -->
    <div v-if="this.postId">
      <h5 class="mt-7 mb-4"><i class="dot"></i> 직영 작성<span style="font-size: 14px; font-weight: 400; color: #04cfe8">(수급업체 작성 결재 상신 → 결재 시 직영(부서장)이 결과 입력 및 파일첨부)</span></h5>
      <div class="writeGridContainer">
        <div>
          <div>DKS 조치 대상</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.이름 }}</p>
          <radio-group :readonly="!stepEditActive" class="w-full" flex :items="['대상', '비대상']" v-model="form.DKS" />
        </div>
      </div>

      <table>
        <colgroup>
          <col width="114" />
        </colgroup>
        <tbody>
          <tr>
            <th>직영 Feed Back<br />(DKS → 업체)</th>
            <td><ml-textarea :readonly="!stepEditActive" v-model="form.feedBack" class="mb-0" /></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import FileUploader from "@/components/FileUploader.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    PrintCheckbox,
    RadioTypeCheck,
    FileDownloadPost,
    NumberInput,
    DateSelector,
    CustomOptionSelector,
    FileUploader,
    RadioGroup,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      stepEditActive: false,
      gridContainerOptions: {
        dataTypes: ["string", "number"],
        labels: ["업체명", "근로자 현황"],
        values: ["업체명", "근로자현황"],
      },
      form: {
        monthDate: "",
        stdInfo: {},
        fileList: [],
        subInfo: {},

        작성활성화: [],

        기술지도기관안전: "",
        기술지도기관보건: "",
        기술지도일시안전: "",
        기술지도일시: "",
        기술지도결과서안전: "",
        결과서첨부: "",
        기술지도사항안전: "",
        기술지도사항보건: "",
        기타특이사항안전: "",
        기타특이사항보건: "",
        개선요청사항: "",

        photoList: [],

        DKS: "대상",
        feedBack: "",
      },
    };
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
    // FileUploader 타이밍 경쟁 회피용: form 최상위 값과 기존 subInfo 하위 값을 모두 대응
    결과서첨부Proxy: {
      get() {
        const own = this.form.결과서첨부;
        if (own && typeof own === "object" && (own.id || own.path)) {
          return own;
        }
        const legacy = this.form.subInfo && this.form.subInfo.결과서첨부;
        if (legacy && typeof legacy === "object" && (legacy.id || legacy.path)) {
          return legacy;
        }
        return own || "";
      },
      set(value) {
        this.$set(this.form, "결과서첨부", value);
        if (this.form.subInfo && "결과서첨부" in this.form.subInfo) {
          this.$delete(this.form.subInfo, "결과서첨부");
        }
      },
    },
    canStepEdit() {
      if (!this.board) return false;
      if (this.board.statusCode !== 'ongoing' && this.board.statusCode !== 'registered') return false;

      const me = this.$store.state.member.memberInfo;
      if (!me || !me.id) return false;

      const meVirtualCompany = me.virtual_company;
      if (!meVirtualCompany || !Array.isArray(meVirtualCompany.full_name)) return false;
      if (!meVirtualCompany.full_name.includes('동국제강')) return false;

      const approvalLine = this.board.approvalLine;
      if (!Array.isArray(approvalLine) || approvalLine.length === 0) return false;

      const current = approvalLine.find(function(item) {
        return item.status_name === '대기' && item.type_code !== 'register';
      });
      if (!current || me.id !== current.user_id) return false;

      return true;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
        this.migrateLegacySubInfoFields();
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
    this.migrateLegacySubInfoFields();
  },
  methods: {
    migrateLegacySubInfoFields() {
      // 기존 문서 호환: subInfo 하위에 저장되어 있던 필드를 form 최상위로 이동
      // (결과서첨부는 FileUploader의 created 타이밍 이슈로 computed 프록시에서 처리)
      const legacyKeys = ["기술지도기관안전", "기술지도기관보건", "기술지도일시"];
      const legacySubInfo = this.form.subInfo;
      if (!legacySubInfo || typeof legacySubInfo !== "object") return;
      for (const key of legacyKeys) {
        const legacyValue = legacySubInfo[key];
        const currentValue = this.form[key];
        const isEmpty =
          currentValue === "" ||
          currentValue === null ||
          currentValue === undefined ||
          (typeof currentValue === "object" && Object.keys(currentValue).length === 0);
        if (isEmpty && legacyValue) {
          this.$set(this.form, key, legacyValue);
        }
        if (key in legacySubInfo) {
          this.$delete(legacySubInfo, key);
        }
      }
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    text-align: center;
    background: white;
    border: 1px solid #cdcdcd;
    padding: 7px;
  }

  th {
    font-weight: 700;
    background: #f9f9f9;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
  }
}
</style>
